import axios from 'axios';
import prepareRequestOptions from '../utils/admin-apis.util';

export const getContactList = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/contact/list${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getContactListCategories = async () => {
  const options = prepareRequestOptions(
    `/admin/contact/categories/search-list`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const getExportData = async (params = '') => {
  const options = prepareRequestOptions(
    `/admin/export/contact${params}`,
    'GET',
    null,
    true
  );

  const response = await axios(options);
  return response.data;
};
